if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
         document.body.classList.add('checkout_btn_load');
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;


const varId = this.submitButton.dataset.varid;


const drawerItemso = Array.from(document.querySelectorAll('[cart-section="drawerordered"]'));

const matchedItemo = drawerItemso.find(item => item.getAttribute('cart-var-id') === varId);

if (matchedItemo) {
  console.log('Match found:', matchedItemo);

  const quantityInputo = matchedItemo.querySelector('.quantity__input');
  if (quantityInputo) {
    const valueo = parseInt(quantityInputo.value, 10);
    const maxo = parseInt(quantityInputo.dataset.maxi, 10);

    if (valueo < maxo) {
      console.log(`Quantity ${valueo} is within limit (${maxo})`);
    } else {
      console.log(`Quantity ${valueo} exceeds max limit (${maxo})`);
       document.querySelector('.error_display_text').innerHTML = 'Maximum order count reached.';
      document.querySelector('.error_display').classList.add('active');
        return; // Stop execution if count is less than 20
    }
  }
}
const drawerItems = Array.from(document.querySelectorAll('[cart-section="drawerordered"]'));
const drawerItemsGift = Array.from(document.querySelectorAll('[cart-section="drawergift"]'));
const matchedItem = drawerItems.find(item => item.getAttribute('cart-var-id') === varId);
const giftInput = document.querySelector('#master-free-gift');
  if (giftInput) {
    const giftProductId = giftInput.getAttribute('date-productid'); // triggering product
  //  alert(giftProductId);
    const giftVarId = giftInput.getAttribute('data-giftid'); // gift variant
    const startDate = parseInt(giftInput.dataset.startdate, 10);
    const endDate = parseInt(giftInput.dataset.enddate, 10);
    const currentDate = parseInt(giftInput.dataset.currentdate, 10);
const giftProductIds = giftInput.getAttribute('date-productid');
     const productIdList = giftProductIds.split(',').map(id => id.trim());
if (productIdList.includes(varId) && currentDate >= startDate && currentDate <= endDate) {
    

      const giftExists = drawerItemsGift.some(item => item.getAttribute('cart-var-id') === giftVarId);

      if (giftExists) {
    //    alert(`Gift with ID ${giftVarId} is already in the cart.`);
      } else {
     //   alert(`Adding gift with ID ${giftVarId} to cart with properties...`);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: giftVarId,
              quantity: 1,
              properties: {
                "customprice": 0,
                "product_type": "Gift"
              }
            }]
          })
        })
        .then(res => res.json())
        .then(data => {
       //   alert('Gift added to cart with properties:', data);
            console.log('Gift added to cart with properties:', data);
          // Optional: update cart UI
        })
        .catch(err => {
          console.error('Error adding gift to cart:', err);
        });
      }
      setTimeout(() => {
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('response',response)
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              setTimeout(() => {
              const giftInputier = document.querySelector('#tiered-free-gift');
      const giftierVarId = giftInputier.getAttribute('data-giftierid'); // gift variant
      const giftVarUser = giftInputier.getAttribute('data-user'); // gift variant ID
      const giftVarCustomer = giftInputier.getAttribute('data-customer'); // gift variant ID
          const startDatet = parseInt(giftInputier.dataset.startdate, 10);
    const endDatet = parseInt(giftInputier.dataset.enddate, 10);
      const currentDatet = parseInt(giftInputier.dataset.currentdate, 10);
//alert(startDatet + 's ' + endDatet + ' ' + currentDatet);
if (currentDatet >= startDatet && currentDatet <= endDatet) {

// Get the number from #kct
let kctValue = parseInt(document.getElementById("kct").textContent.trim(), 10);

// Get the value from date-totalvalue attribute
let totalValue = parseInt(document.getElementById("tiered-free-gift").getAttribute("date-totalvalue"), 10);

// Get the .customp input inside the same form as 'this'


// Compare


  if (kctValue > totalValue) {
     //   alert(`Adding gift with ID ${giftVarId} to cart with properties...`);


     const drawerItemsGiftz = Array.from(document.querySelectorAll('[cart-section="drawergift"]'));
        const giftExistsodcz = drawerItemsGiftz.some(item => item.getAttribute('cart-var-id') === giftVarIddc);

    if (!giftExistsodcz) {
      document.body.classList.add('checkout_btn_load');
let giftAllowedf = false;

console.log("----------------------------");
console.log('chu' + giftierVarId);
    if (giftVarUser === "all") {
      giftAllowedf = true;
    } else if (giftVarUser === "exclusive" && giftVarCustomer === "1") {
      giftAllowedf = true;
    }

    if (giftAllowedf) {
console.log('iya');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: giftierVarId,
              quantity: 1,
              properties: {
                "customprice": 0,
                "product_type": "Gift"
              }
            }]
          })
        })
        .then(res => res.json())
        .then(data => {
       //   alert('Gift added to cart with properties:', data);
            console.log('Gift added to cart with properties:', data);
            updateMiniCartMaster();
          // Optional: update cart UI
        })
        .catch(err => {
          console.error('Error adding gift to cart:', err);
        });
      } else {


         const giftExistsdcnf = drawerItemsGift.some(itemc => itemc.getAttribute('cart-var-id') === giftierVarId);
   
    if (giftExistsdcnf) {
  //     alert('removegift');
      const giftRemoveButtondcnf = document.querySelector(`cart-remove-button[cart-remove-id="${giftierVarId}"]`);

      if (giftRemoveButtondcnf) {
        const anchordcnf = giftRemoveButtondcnf.querySelector('a[href*="/cart/change?id="]');
        
  if (anchordcnf) {
  const hrefdcnf = anchordcnf.getAttribute('href');  
  const urlParamsnf = new URLSearchParams(hrefdcnf.split('?')[1]);  
  const lineItemKeynf = urlParamsnf.get('id');  

  if (lineItemKeynf) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKeynf,
        quantity: 0
      })
    })
    .then(res => res.json())
    .then(cart => {
      console.log('✅ Removed item via POST. Updated cart:', cart);
      // optionally update your cart drawer here
      updateMiniCartMaster();
    })
    .catch(err => console.error('❌ Error removing item:', err));
  }
}

      }
    }



      }
    }
    }
  }
}, 500);
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }






          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }, 1000);
      return;
    } else {
   //   alert('Gift not eligible based on date or product mismatch.');
    }
  }
if (matchedItem) {
  console.log('Match found:', matchedItem);

  const quantityInput = matchedItem.querySelector('.quantity__input');
  if (quantityInput) {
    const value = parseInt(quantityInput.value, 10);
    const max = parseInt(quantityInput.dataset.maxi, 10);

    if (value < max) {
      console.log(`Quantity ${value} is within limit (${max})`);
      
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('response',response)
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
setTimeout(() => {

              const giftInputier = document.querySelector('#tiered-free-gift');
      const giftierVarId = giftInputier.getAttribute('data-giftierid'); // gift variant
      const giftVarUser = giftInputier.getAttribute('data-user'); // gift variant ID
      const giftVarCustomer = giftInputier.getAttribute('data-customer'); // gift variant ID
          const startDatet = parseInt(giftInputier.dataset.startdate, 10);
    const endDatet = parseInt(giftInputier.dataset.enddate, 10);
      const currentDatet = parseInt(giftInputier.dataset.currentdate, 10);
  //    
if (currentDatet >= startDatet && currentDatet <= endDatet) {

// Get the number from #kct
let kctValue = parseInt(document.getElementById("kct").textContent.trim(), 10);

// Get the value from date-totalvalue attribute
let totalValue = parseInt(document.getElementById("tiered-free-gift").getAttribute("date-totalvalue"), 10);

// Get the .customp input inside the same form as 'this'


// Compare


  if (kctValue > totalValue) {

    const drawerItemsGiftz = Array.from(document.querySelectorAll('[cart-section="drawergift"]'));
        const giftExistsodcz = drawerItemsGiftz.some(item => item.getAttribute('cart-var-id') === giftVarIddc);

    if (!giftExistsodcz) {
      document.body.classList.add('checkout_btn_load');
//alert(startDatet + ' p' + endDatet + ' ' + currentDatet);
     //   alert(`Adding gift with ID ${giftVarId} to cart with properties...`);
let giftAllowedf = false;
console.log("----------------------------");
console.log('chu' + giftierVarId);
    if (giftVarUser === "all") {
      giftAllowedf = true;
    } else if (giftVarUser === "exclusive" && giftVarCustomer === "1") {
      giftAllowedf = true;
    }

    if (giftAllowedf) {
console.log('iya');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: giftierVarId,
              quantity: 1,
              properties: {
                "customprice": 0,
                "product_type": "Gift"
              }
            }]
          })
        })
        .then(res => res.json())
        .then(data => {
       //   alert('Gift added to cart with properties:', data);
            console.log('Gift added to cart with properties:', data);
      updateMiniCartMaster();
          // Optional: update cart UI
        })
        .catch(err => {
          console.error('Error adding gift to cart:', err);
        });
      } else {


         const giftExistsdcnf = drawerItemsGift.some(itemc => itemc.getAttribute('cart-var-id') === giftierVarId);
   
    if (giftExistsdcnf) {
  //     alert('removegift');
      const giftRemoveButtondcnf = document.querySelector(`cart-remove-button[cart-remove-id="${giftierVarId}"]`);

      if (giftRemoveButtondcnf) {
        const anchordcnf = giftRemoveButtondcnf.querySelector('a[href*="/cart/change?id="]');
        
  if (anchordcnf) {
  const hrefdcnf = anchordcnf.getAttribute('href');  
  const urlParamsnf = new URLSearchParams(hrefdcnf.split('?')[1]);  
  const lineItemKeynf = urlParamsnf.get('id');  

  if (lineItemKeynf) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKeynf,
        quantity: 0
      })
    })
    .then(res => res.json())
    .then(cart => {
      console.log('✅ Removed item via POST. Updated cart:', cart);
      // optionally update your cart drawer here
      updateMiniCartMaster();
    })
    .catch(err => console.error('❌ Error removing item:', err));
  }
}

      }
    }



      }
    }
  }
  }
}, 500);
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
    } else {
    document.querySelector('.error_display_text').innerHTML = 'Maximum product limit reached';
      document.querySelector('.error_display').classList.add('active');
    }
  }
} else {
  
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('response',response)
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
setTimeout(() => {
              const giftInputier = document.querySelector('#tiered-free-gift');
      const giftierVarId = giftInputier.getAttribute('data-giftierid'); // gift variant
      const giftVarUser = giftInputier.getAttribute('data-user'); // gift variant ID
      const giftVarCustomer = giftInputier.getAttribute('data-customer'); // gift variant ID
          const startDatet = parseInt(giftInputier.dataset.startdate, 10);
    const endDatet = parseInt(giftInputier.dataset.enddate, 10);
      const currentDatet = parseInt(giftInputier.dataset.currentdate, 10);
//alert(startDatet + ' g' + endDatet + ' ' + currentDatet);
if (currentDatet >= startDatet && currentDatet <= endDatet) {
 
// Get the number from #kct
let kctValue = parseInt(document.getElementById("kct").textContent.trim(), 10);

// Get the value from date-totalvalue attribute
let totalValue = parseInt(document.getElementById("tiered-free-gift").getAttribute("date-totalvalue"), 10);

// Get the .customp input inside the same form as 'this'


// Compare


  if (kctValue > totalValue) {

    const drawerItemsGiftz = Array.from(document.querySelectorAll('[cart-section="drawergift"]'));
        const giftExistsodcz = drawerItemsGiftz.some(item => item.getAttribute('cart-var-id') === giftVarIddc);

    if (!giftExistsodcz) {
document.body.classList.add('checkout_btn_load');
     //   alert(`Adding gift with ID ${giftVarId} to cart with properties...`);
let giftAllowedf = false;

console.log("----------------------------");
console.log('chu' + giftierVarId);
    if (giftVarUser === "all") {
      giftAllowedf = true;
    } else if (giftVarUser === "exclusive" && giftVarCustomer === "1") {
      giftAllowedf = true;
    }

    if (giftAllowedf) {
console.log('iya');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: giftierVarId,
              quantity: 1,
              properties: {
                "customprice": 0,
                "product_type": "Gift"
              }
            }]
          })
        })
        .then(res => res.json())
        .then(data => {
       //   alert('Gift added to cart with properties:', data);
            console.log('Gift added to cart with properties:', data);
          updateMiniCartMaster();
          // Optional: update cart UI
        })
        .catch(err => {
          console.error('Error adding gift to cart:', err);
        });
      } else {


         const giftExistsdcnf = drawerItemsGift.some(itemc => itemc.getAttribute('cart-var-id') === giftierVarId);
   
    if (giftExistsdcnf) {
  //     alert('removegift');
      const giftRemoveButtondcnf = document.querySelector(`cart-remove-button[cart-remove-id="${giftierVarId}"]`);

      if (giftRemoveButtondcnf) {
        const anchordcnf = giftRemoveButtondcnf.querySelector('a[href*="/cart/change?id="]');
        
  if (anchordcnf) {
  const hrefdcnf = anchordcnf.getAttribute('href');  
  const urlParamsnf = new URLSearchParams(hrefdcnf.split('?')[1]);  
  const lineItemKeynf = urlParamsnf.get('id');  

  if (lineItemKeynf) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKeynf,
        quantity: 0
      })
    })
    .then(res => res.json())
    .then(cart => {
      console.log('✅ Removed item via POST. Updated cart:', cart);
      // optionally update your cart drawer here
      updateMiniCartMaster();
    })
    .catch(err => console.error('❌ Error removing item:', err));
  }
}

      }
    }



      }
    }
  }
  }
}, 500);
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

          });
}
     








        
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}













// // GWP

function parseDate(str) {
  if (!str) return null;
  const [datePart, hourPart] = str.trim().split(' ');
  const parts = datePart.split('/');
  const dd   = String(parts[0]).padStart(2,'0');
  const mm   = String(parts[1]).padStart(2,'0');
  const yyyy = parts[2];
  const hh   = String(hourPart || '0').padStart(2,'0');
  return new Date(`${yyyy}-${mm}-${dd}T${hh}:00:00`);
}

// global run flags
var gwpRunning   = false;
var gwpQueued    = false;
var gwpDebounceT = null;
var gwpAddLock   = false; // prevent double add

function gwpSchedule(delay = 300) {
  clearTimeout(gwpDebounceT);
  gwpDebounceT = setTimeout(() => runGWP(null), delay);
}

// fetch current cart

   function apiGet(retry = 0) {
  return fetch('/cart.js', { credentials: 'same-origin' })
    .then(async r => {
      if (r.status === 429 && retry < 3) {
        console.warn('[GWP] 429 apiGet retry', retry + 1);
        await new Promise(res => setTimeout(res, 800 * (retry + 1)));
        return apiGet(retry + 1);
      }

      if (!r.ok) return null;

      const text = await r.text();

      if (!text || text.trim().startsWith('<')) {
        console.warn('[GWP] HTML response instead of JSON');
        return null;
      }

      try {
        return JSON.parse(text);
      } catch (e) {
        console.warn('[GWP] JSON parse failed');
        return null;
      }
    })
    .catch(() => null);
}


// add gift to cart
function apiAddGift(variantId, retry = 0) {
  return fetch('/cart/add.js', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: +variantId, quantity: 1,
      properties: { customprice: '0', product_type: 'Gift', gwp: 'true' } }] })
  }).then(r => {
    if (r.ok) return r.json();
    if (retry < 3) {
      console.warn('[GWP] add failed ' + r.status + ', retry ' + (retry+1));
      return new Promise(res => setTimeout(res, 400 * (retry + 1)))
        .then(() => apiAddGift(variantId, retry + 1));
    }
    return Promise.reject('add failed after retries: ' + r.status);
  });
}

// remove gift from cart
function apiRemoveGift(key, retry = 0) {
  return fetch('/cart/change.js', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(r => {
    if ((r.status === 429 || r.status === 400) && retry < 3) {
      console.warn('[GWP] ' + r.status + ' apiRemove retry', retry + 1);
      return new Promise(res => setTimeout(res, 500 * (retry + 1)))
        .then(() => apiRemoveGift(key, retry + 1));
    }
    return r.ok ? r.json() : Promise.reject('remove ' + r.status);
  }).catch(e => { console.error('[GWP] remove error:', e); return null; });
}

// wipe gift nodes from DOM
function domRemoveAllGifts() {
  const wrap = document.querySelector('#CartDrawer-CartItems .cart-items');
  if (!wrap) return;

  // remove heading + body pairs
  Array.from(wrap.querySelectorAll('.order-product-heading'))
    .filter(h => h.querySelector('h2')?.textContent?.trim() === 'Our Gift To You')
    .forEach(gh => {
      const body = gh.nextElementSibling;
      if (body?.classList.contains('cart-items__body')) body.remove();
      gh.remove();
    });

  // catch stray gift items too
  Array.from(wrap.querySelectorAll('[cart-section="drawerwergift"], [cart-section="drawergift"]'))
    .forEach(el => {
      const parent = el.closest('.cart-items__body');
      el.remove();
      if (parent && parent.querySelectorAll('.cart-item').length === 0) parent.remove();
    });
}

// how many gift sections visible
function domGiftCount() {
  const wrap = document.querySelector('#CartDrawer-CartItems .cart-items');
  if (!wrap) return 0;
  return Array.from(wrap.querySelectorAll('.order-product-heading'))
    .filter(h => h.querySelector('h2')?.textContent?.trim() === 'Our Gift To You').length;
}

// re-render cart drawer HTML
function injectSection(retry = 0) {
  return fetch('/?section_id=cart-drawer', { credentials: 'same-origin' })
    .then(r => {
      if (r.status === 429 && retry < 3)
        return new Promise(res => setTimeout(res, 600 * (retry + 1)))
          .then(() => injectSection(retry + 1));
      if (!r.ok) return Promise.reject('section ' + r.status);
      return r.text();
    })
    .then(html => {
      const doc      = new DOMParser().parseFromString(html, 'text/html');
      const oldInner = document.querySelector('.drawer__inner');
      const newInner = doc.querySelector('.drawer__inner');
      const isEmpty  = !!doc.querySelector('.drawer__inner-empty');

      // cart is empty
      if (isEmpty && oldInner && newInner) {
        oldInner.innerHTML = newInner.innerHTML;
        document.querySelector('cart-drawer')?.classList.add('is-empty', 'cart-drawer-empty');
        document.querySelector('cart-drawer-items')?.classList.add('is-empty');
        if (typeof updateMiniCartMaster === 'function') try { updateMiniCartMaster(); } catch(e) {}
        return;
      }

      const newW = doc.querySelector('#CartDrawer-CartItems .cart-items');
      const oldW = document.querySelector('#CartDrawer-CartItems .cart-items');
      if (!newW || !oldW) return;

      document.querySelector('cart-drawer')?.classList.remove('is-empty', 'cart-drawer-empty');
      document.querySelector('cart-drawer-items')?.classList.remove('is-empty');

      // clear before re-inserting gift
      // domRemoveAllGifts();

      const newGH = Array.from(newW.querySelectorAll('.order-product-heading'))
        .find(h => h.querySelector('h2')?.textContent?.trim() === 'Our Gift To You');
      if (newGH) {
        const newB = newGH.nextElementSibling;
        const ordH = Array.from(oldW.querySelectorAll('.order-product-heading'))
          .find(h => !h.querySelector('h2')?.textContent?.includes('Redeemed'));
        oldW.insertBefore(newGH.cloneNode(true), ordH || null);
        if (newB?.classList.contains('cart-items__body'))
          oldW.insertBefore(newB.cloneNode(true), ordH || null);
      }

      // safety — drop extra headings
      const allGiftHeadings = Array.from(oldW.querySelectorAll('.order-product-heading'))
        .filter(h => h.querySelector('h2')?.textContent?.trim() === 'Our Gift To You');
      if (allGiftHeadings.length > 1) {
        allGiftHeadings.slice(1).forEach(gh => {
          const body = gh.nextElementSibling;
          if (body?.classList.contains('cart-items__body')) body.remove();
          gh.remove();
        });
      }

      // sync totals + heading text
      ['.totals__total-value', '.drawer__heading'].forEach(sel => {
        const n = doc.querySelector(sel), o = document.querySelector(sel);
        if (n && o) o.innerHTML = n.innerHTML;
      });

      if (typeof updateMiniCartMaster === 'function') try { updateMiniCartMaster(); } catch(e) {}
    })
    .catch(e => console.error('[GWP] inject:', e));
}

// one inject at a time
if (typeof injectLock === 'undefined') {
  var injectLock = false;
  var injectQueued = false;
}


async function safeInject() {
  if (injectLock) {
    injectQueued = true;
    return;
  }
  injectLock   = true;
  injectQueued = false;
  domRemoveAllGifts(); // always wipe first
  try {
    await injectSection();
  } finally {
    injectLock = false;
    if (injectQueued) {
      // flush queued call
      injectQueued = false;
      await safeInject();
    }
  }
}

// watch DOM for sneak duplicates
(function() {
  let observerDebounce = null;
  const observer = new MutationObserver(() => {
    clearTimeout(observerDebounce);
    observerDebounce = setTimeout(() => {
      const oldW = document.querySelector('#CartDrawer-CartItems .cart-items');
      if (!oldW) return;
      const allGH = Array.from(oldW.querySelectorAll('.order-product-heading'))
        .filter(h => h.querySelector('h2')?.textContent?.trim() === 'Our Gift To You');
      if (allGH.length > 1) {
        console.log('[GWP] Observer: duplicate gift detected, removing extras');
        allGH.slice(1).forEach(gh => {
          const body = gh.nextElementSibling;
          if (body?.classList.contains('cart-items__body')) body.remove();
          gh.remove();
        });
      }
    }, 50);
  });

  function attachObserver() {
    const target = document.querySelector('#CartDrawer-CartItems');
    if (target) {
      observer.observe(target, { childList: true, subtree: true });
    } else {
      setTimeout(attachObserver, 500);
    }
  }
  document.addEventListener('DOMContentLoaded', attachObserver);
})();

// which gift variant to show
function getTarget(cart) {
  const el = document.querySelector('#tiered-free-gift');
  if (!el) return null;

  const now  = new Date();
  const cust = el.getAttribute('data-customer');
  const ok   = s => s === 'all' || (s === 'exclusive' && cust === '1');
  const active = (s, e, u) =>
    ((!s&&!e)||(now&&s&&e&&now>=s&&now<=e)) && ok(u);

  const o1id  = el.getAttribute('data-offer2-id');
  const o1min = parseInt(el.getAttribute('data-tier1min') || '45');
  const a1    = active(parseDate(el.dataset.start2), parseDate(el.dataset.end2), el.getAttribute('data-user2'));

  const o2id  = el.getAttribute('data-offer3-id');
  const o2min = parseInt(el.getAttribute('data-tier2min') || '90');
  const a2    = active(parseDate(el.dataset.start3), parseDate(el.dataset.end3), el.getAttribute('data-user3'));

  // exclude gift items from spend total
  let total = 0;
  cart.items.forEach(i => {
    if (i.properties?.product_type !== 'Gift') total += i.final_line_price / 100;
  });
  // total = Math.floor(total);
  total = parseFloat(total.toFixed(2));
  console.log('[GWP] total=' + total + ' | a1=' + a1 + ' | a2=' + a2 + ' | o1min=' + o1min + ' | o2min=' + o2min);

  if (total <= 0) return null;
  if (total >= o2min && a2) return o2id; // tier 2 
  if (total >= o1min && a1) return o1id; // tier 1 
  return null;
}

// main gift decision logic
async function _gwpLogic(cart) {
  const gifts    = cart.items.filter(i => i.properties?.product_type === 'Gift');
  const nonGifts = cart.items.filter(i => i.properties?.product_type !== 'Gift');

  // empty cart — remove everything
  if (nonGifts.length === 0) {
    if (gifts.length > 0)
      await Promise.all(gifts.map(g => apiRemoveGift(g.key).catch(() => {})));
    await safeInject();
    return;
  }

  const target = getTarget(cart);
  console.log('[GWP] target=' + target + ' | gifts=' + gifts.length + ' | nonGifts=' + nonGifts.length);

  const correctGifts = gifts.filter(g => String(g.variant_id) === String(target));
  const wrongGifts   = gifts.filter(g => String(g.variant_id) !== String(target));
  const duplicates   = correctGifts.slice(1); // keep only first

  const toRemove = [...wrongGifts, ...duplicates];
  if (toRemove.length > 0) {
    console.log('[GWP] removing', toRemove.length, 'wrong/duplicate');
    await Promise.all(toRemove.map(g => apiRemoveGift(g.key).catch(() => {})));
    // restart with clean cart
    const freshAfterRemove = await apiGet();
    if (freshAfterRemove) { await _gwpLogic(freshAfterRemove); }
    return;
  }

  // no gift needed
  if (!target) {
    domRemoveAllGifts();
    await safeInject();
    return;
  }

  // already perfect — skip
  if (correctGifts.length === 1 && duplicates.length === 0 && domGiftCount() === 1) {
    console.log('[GWP] skip — already correct');
    return;
  }

  // cart ok, DOM stale
  if (correctGifts.length === 1 && duplicates.length === 0) {
    await safeInject();
    return;
  }

  // need to add gift
  if (correctGifts.length === 0) {
    if (gwpAddLock) {
      console.log('[GWP] addLock active — skipping duplicate add');
      return;
    }
    gwpAddLock = true;
    try {
      // double-check before adding
      const freshCart = await apiGet();
      const alreadyAdded = (freshCart?.items || []).filter(i =>
        i.properties?.product_type === 'Gift' &&
        String(i.variant_id) === String(target)
      );
      if (alreadyAdded.length > 0) {
        console.log('[GWP] race: gift already in cart, skipping add');
        await safeInject();
        return;
      }

      console.log('[GWP] adding', target);
      await apiAddGift(target);

      // confirm it landed
      const verify = await apiGet();
      const added  = (verify?.items || []).filter(i =>
        i.properties?.product_type === 'Gift' &&
        String(i.variant_id) === String(target)
      );
      if (added.length === 0) {
        console.warn('[GWP] verify failed — retrying add');
        await apiAddGift(target);
      }
    } finally {
      gwpAddLock = false;
    }
  }

  await safeInject();
}

// entry point, prevents overlap
var lastGwpRun = 0;

async function runGWP(passedCart) {
  const now = Date.now();

 
  if (now - lastGwpRun < 2000) {
    console.log('[GWP] throttled');
    return;
  }

  if (gwpRunning) {
    gwpQueued = true;
    return;
  }


  lastGwpRun = now;

  gwpRunning = true;
  gwpQueued  = false;

  try {
    const cart = passedCart || await apiGet();

    if (!cart || !cart.items) {
      console.warn('[GWP] cart fetch failed, skipping run');
      return;
    }

    await _gwpLogic(cart);

  } catch(e) {
    console.error('[GWP]', e);
  } finally {
    gwpRunning = false;

    if (gwpQueued) {
      gwpQueued = false;
      setTimeout(() => runGWP(null), 300);
    }
  }
}

// public aliases for theme calls
function syncGift()                   { runGWP(null); }
function handleTieredGifts()          { runGWP(null); }
function handleTieredGiftsDebounced() { runGWP(null); }
function refreshGiftUI()              { runGWP(null); }
function refreshCartUI()              { runGWP(null); }

// intercept cart fetch calls
(function() {
  const _fetch = window.fetch;
  window.fetch = async function() {
    const url = typeof arguments[0] === 'string'
      ? arguments[0] : (arguments[0]?.url || '');

    const res = await _fetch.apply(this, arguments);
    if (gwpRunning) return res;
    if (url.includes('section_id=cart-drawer')) return res;

  if (url.includes('/cart/add')) {
  res.clone().json().then(data => {
    const items = data?.items || (data?.id ? [data] : []);
    if (items.some(i => i?.properties?.product_type === 'Gift')) return;
    gwpSchedule(300);
  }).catch(() => {});
}

if (url.includes('/cart/change') && !url.includes('/cart/update')) {
  res.clone().json().then(data => {
    if (data?.items && !data.errors) {
      const hasGift = data.items.some(i => i?.properties?.product_type === 'Gift');
      if (hasGift) gwpSchedule(150);
    }
  }).catch(() => {});
}

    return res;
  };
})();

// no page page load
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => runGWP(null), 500);
});
document.addEventListener('cart:updated', () => gwpSchedule(400));








